import { Controller } from '@hotwired/stimulus'

export default class NewInvestmentFlowSubscriptionRequestController extends Controller {
  static targets = ['amount', 'submitButton'];

  checkAmountAndEnableSubmitButton() {
    // Read the hidden numeric field: the display input holds the fr-FR formatted
    // value ("1 234 €"), which parseInt would truncate at the thousands separator.
    const amount = parseInt(this.amountTarget.value, 10);
    this.submitButtonTarget.disabled = isNaN(amount) || amount <= 0;
  }
}
